import { useState } from 'react'
import { Dialog, DialogPanel } from '@headlessui/react'
import { XMarkIcon } from '@heroicons/react/24/outline'
import banners from '../src/banners.png'

const navigation = [
  { name: 'Kronos köpskydd', href: '/kronos-secure' },
  { name: 'Kronos Certified', href: '/kronos-certified' },
  { name: 'Kontrollera certifiering', href: '/kronos-certified-control' },
  { name: 'Klockvärdering', href: '/klockvardering' },
  { name: 'Företagsannonsering', href: '/foretagsannonsering' },
  { name: 'Marknadsföring', href: '/marknadsforing' },
  { name: 'Blogg', href: '/blogg' },
  { name: 'Integritetspolicy', href: '/integritetspolicy' },
  { name: 'Användarvillkor', href: '/anvandarvillkor' },
]

function Marknadsforing({ siteLogo }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <div className="min-h-screen bg-white text-slate-900">
      <header className="fixed inset-x-0 top-0 z-50 bg-white shadow">
        <nav className="flex items-center justify-between p-6 lg:px-8">
          <a href="/" className="flex items-center -m-1.5 p-1.5">
            <span className="sr-only">Krono</span>
            <img alt="Krono Logo" src={siteLogo} className="h-6 w-auto rounded-md" />
          </a>

          <div className="flex lg:hidden">
            <button
              type="button"
              className="p-2.5 text-gray-700 rounded-md"
              onClick={() => setMobileMenuOpen(true)}
            >
              <span className="sr-only">Open menu</span>
              <svg
                className="h-6 w-6"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth="1.5"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M3.75 6.75h16.5M3.75 12h16.5m-16.5 5.25h16.5"
                />
              </svg>
            </button>
          </div>

          <div className="hidden lg:flex lg:gap-x-8">
            {navigation.map((item) => (
              <a
                key={item.name}
                href={item.href}
                className="text-sm font-semibold text-gray-900 hover:underline"
              >
                {item.name}
              </a>
            ))}
          </div>
        </nav>

        {/* Mobile menu */}
        <Dialog open={mobileMenuOpen} onClose={setMobileMenuOpen} className="lg:hidden">
          <div className="fixed inset-0 z-50" />
          <DialogPanel className="fixed inset-y-0 right-0 z-50 w-full max-w-sm bg-white px-6 py-6 overflow-y-auto shadow-lg">
            <div className="flex items-center justify-between">
              <button
                type="button"
                onClick={() => setMobileMenuOpen(false)}
                className="p-2.5 text-gray-700 rounded-md"
              >
                <span className="sr-only">Close menu</span>
                <XMarkIcon className="h-6 w-6" aria-hidden="true" />
              </button>
            </div>
            <div className="mt-6 space-y-2">
              {navigation.map((item) => (
                <a
                  key={item.name}
                  href={item.href}
                  className="block rounded-lg px-3 py-2 text-base font-semibold text-gray-900 hover:bg-gray-50"
                >
                  {item.name}
                </a>
              ))}
            </div>
          </DialogPanel>
        </Dialog>
      </header>

      <main className="">
        <section className="relative isolate px-5 pb-16 pt-14 sm:px-8 sm:pb-20 sm:pt-20 lg:pb-24 lg:pt-24">
          <div className="absolute inset-x-0 top-0 -z-10 h-[520px] bg-whitee" />
          <div className="mx-auto grid max-w-7xl items-center gap-12 lg:grid-cols-[0.9fr_1.1fr] lg:gap-16">
            <div className="mx-auto max-w-2xl text-center lg:mx-0 lg:text-left">
              <div className="mb-6 inline-flex items-center gap-2 rounded-full border border-sky-100 bg-white px-4 py-2 text-xs font-bold uppercase tracking-[0.16em] text-sky-800 shadow-sm shadow-sky-900/5">
                Marknadsföring på Kronos
              </div>
              <h1 className="font-poppins text-4xl font-bold tracking-tight text-slate-950 sm:text-5xl lg:text-6xl lg:leading-[1.08]">
                Nå ut till människor som älskar klockor
              </h1>
              <p className="mt-6 text-lg leading-8 text-slate-600 sm:text-xl">
                Lyft ditt varumärke i en nischad miljö där klockintresset redan finns. Med
                annonsering på Kronos kan ditt företag synas för en relevant publik med ett genuint
                intresse för klockor.
              </p>
              <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row lg:justify-start">
                <a
                  href="mailto:info@kronos.se?subject=Marknadsf%C3%B6ring%20p%C3%A5%20Kronos"
                  className="inline-flex w-full items-center justify-center rounded-xl bg-sky-700 px-6 py-3.5 text-sm font-bold text-white shadow-lg shadow-sky-700/20 transition hover:-translate-y-0.5 hover:bg-sky-800 sm:w-auto"
                >
                  Kontakta oss
                  <span className="ml-2" aria-hidden="true">
                    →
                  </span>
                </a>
                <a
                  href="#annonsytor"
                  className="inline-flex w-full items-center justify-center rounded-xl border border-slate-200 bg-white px-6 py-3.5 text-sm font-bold text-slate-800 transition hover:border-sky-200 hover:bg-sky-50 sm:w-auto"
                >
                  Se annonsytorna
                </a>
              </div>
              <div className="mt-8 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm font-medium text-slate-500 lg:justify-start">
                <span className="inline-flex items-center gap-2">
                  <span className="text-sky-600">✓</span> Nischad målgrupp
                </span>
                <span className="inline-flex items-center gap-2">
                  <span className="text-sky-600">✓</span> Synlighet i rätt sammanhang
                </span>
              </div>
            </div>

            <div id="annonsytor" className="relative mx-auto w-full max-w-2xl scroll-mt-28">
              <div className="absolute -inset-4 rounded-[2rem] bg-gradient-to-br from-sky-100/80 via-slate-100/50 to-white blur-2xl" />
              <div className="relative overflow-hidden rounded-3xl border border-slate-100 bg-white p-3 shadow-2xl shadow-slate-900/10 sm:p-5">
                <div className="mb-3 flex items-center justify-between px-2 pt-1 sm:px-3">
                  <div>
                    <p className="text-xs font-bold uppercase tracking-[0.16em] text-sky-700">
                      Annonsera på Kronos
                    </p>
                    <p className="mt-1 text-sm font-semibold text-slate-800">
                      Synlighet för ditt varumärke
                    </p>
                  </div>
                  <span className="rounded-full bg-sky-50 px-3 py-1.5 text-xs font-bold text-sky-800">
                    Digital räckvidd
                  </span>
                </div>
                <img
                  src={banners}
                  alt="Exempel på annonsbanners på Kronos"
                  className="mx-auto max-h-[460px] w-full rounded-2xl object-contain sm:max-h-[540px] lg:max-h-[600px]"
                />
                <div className="mt-3 rounded-2xl border border-slate-100 bg-slate-50/90 p-4 sm:p-5">
                  <p className="text-sm font-bold text-slate-900">Ditt företag i fokus</p>
                  <p className="mt-1 text-sm leading-6 text-slate-600">
                    Visa upp ditt erbjudande där klockintresserade redan upptäcker, jämför och
                    utforskar klockor.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="border-y border-slate-100 bg-slate-50/70 px-5 py-16 sm:px-8 sm:py-20">
          <div className="mx-auto max-w-5xl text-center">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-700">
              Rätt sammanhang gör skillnad
            </p>
            <h2 className="mx-auto mt-4 max-w-3xl font-poppins text-3xl font-bold tracking-tight text-slate-950 sm:text-4xl">
              Marknadsför ditt företag inför en engagerad klockpublik
            </h2>
            <p className="mx-auto mt-5 max-w-3xl text-base leading-8 text-slate-600 sm:text-lg">
              Kronos samlar klockintresserade på en och samma plats. Det ger företag möjlighet att
              presentera sitt varumärke i ett relevant sammanhang och bygga igenkänning hos personer
              som uppskattar kvalitet, design och klockor.
            </p>
            <div className="mt-10 grid gap-4 text-left sm:grid-cols-3">
              <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm shadow-slate-900/[0.03]">
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-sky-50 text-xl text-sky-700">
                  ◎
                </div>
                <h3 className="font-poppins text-base font-bold text-slate-900">
                  Relevant målgrupp
                </h3>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Nå personer som aktivt intresserar sig för klockor och klockrelaterade produkter.
                </p>
              </div>
              <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm shadow-slate-900/[0.03]">
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-sky-50 text-xl text-sky-700">
                  ✦
                </div>
                <h3 className="font-poppins text-base font-bold text-slate-900">
                  Synlighet för varumärket
                </h3>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Presentera ditt företag med annonsytor som passar in i Kronos digitala miljö.
                </p>
              </div>
              <div className="rounded-2xl border border-slate-100 bg-white p-6 shadow-sm shadow-slate-900/[0.03]">
                <div className="mb-4 flex h-11 w-11 items-center justify-center rounded-xl bg-sky-50 text-xl text-sky-700">
                  ↗
                </div>
                <h3 className="font-poppins text-base font-bold text-slate-900">
                  En växande plattform
                </h3>
                <p className="mt-2 text-sm leading-6 text-slate-600">
                  Bli synlig på en plattform med tydligt fokus på klockor och klockintresserade.
                </p>
              </div>
            </div>
          </div>
        </section>

        <section className="px-5 py-16 sm:px-8 sm:py-20">
          <div className="mx-auto max-w-4xl rounded-3xl bg-slate-950 px-6 py-10 text-center shadow-xl shadow-slate-900/10 sm:px-12 sm:py-14">
            <p className="text-xs font-bold uppercase tracking-[0.2em] text-sky-300">
              Låt oss prata möjligheter
            </p>
            <h2 className="mt-4 font-poppins text-3xl font-bold tracking-tight text-white sm:text-4xl">
              Vill du marknadsföra ditt företag på Kronos?
            </h2>
            <p className="mx-auto mt-4 max-w-2xl text-base leading-7 text-slate-300">
              Hör av dig så berättar vi mer om våra annonsmöjligheter och hjälper dig att hitta ett
              upplägg som passar ditt företag.
            </p>
            <a
              href="mailto:info@kronos.se?subject=Marknadsf%C3%B6ring%20p%C3%A5%20Kronos"
              className="mt-8 inline-flex items-center justify-center rounded-xl bg-white px-6 py-3.5 text-sm font-bold text-slate-950 transition hover:-translate-y-0.5 hover:bg-sky-50"
            >
              info@kronos.se
              <span className="ml-2" aria-hidden="true">
                →
              </span>
            </a>
          </div>
        </section>
      </main>
    </div>
  )
}

export default Marknadsforing
